import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  Menu,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import theme from "../../theme";
import EmailIcon from "@mui/icons-material/Email";
import { start } from "repl";
import useButtonStyles from "../../styles/useButtonStyles";
import ActivityLogNew from "./ActivityLogNew";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import ActivityLogDrawerNew from "./ActivityLogDrawerNew";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";
import { useNavigate, useParams } from "react-router";
import formatDates, {
  dateFormat,
  getFormattedDate,
} from "../../util/dateFormat";
import NoActivity from "../../assets/NoActivity.png";
import Loader from "../ui/Loader";
import useTableStyles from "../../styles/useTableStyles";
import { constant } from "../../constants";
import BasicModal from "../ui/BasicModal";
import { useAppSelector } from "../../redux/hooks";
import { filterConstants } from "../../constants/AppConstants";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";

interface ArrayPropsType {
  expiryDate: string;
  points: number;
}
export type MemberDetailsHeaderNewProps = {
  memberName: string;
  memberTier: string;
  loyaltyNo: string | number;
  loyaltyPoints: string | number;
  status: string;
  carpark: string;
  memberSince: string;
  email: string;
  expiryPoints: string;
  expiryDate: string;
  nextSlab: string;
  slabExpiryDate: string;
  pointsValidityData: ArrayPropsType[];
  min_purchase_value_required: string | number;
  currentSlab: string;
  gap_to_upgrade: string;
  upgrade_by: string;
  gap_to_renew: string;
  renew_by: string;
  yuuId?: string | number;
  yuu_status?: string;
  show_yuu: boolean;
};

export let activityLogRefresh: Function;

const MemberDetailsHeaderNew: React.FunctionComponent<
  MemberDetailsHeaderNewProps
> = (props: MemberDetailsHeaderNewProps) => {
  const { getUserPermission: getDeletePermission } = usePermissionGetter(
    "members",
    "members_search"
  );
 

  const tableStyle = useTableStyles();
  const buttonStyles = useButtonStyles();
  const initials = props.memberName ? props.memberName.split(" ") : "";
  const start = initials[0]?.slice(0, 1).toUpperCase();
  const end = initials[1]?.slice(0, 1).toUpperCase();
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [activityLogData, setActivityLogData] = useState([]);
  const [openActivityLog, setActivityLog] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigate = useNavigate();
  const params = useParams();
  const { memberId } = params;
  const fName = props.memberName.split(" ")[0];
  const memberDetails = useAppSelector(
    (state: any) => state.persistReducers.getMemberList?.membersList
  );
  const handleCopyClick = () => {
    const loyaltyNoAsString = String(props.loyaltyNo);
    navigator.clipboard.writeText(loyaltyNoAsString);
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  const emailObj = {
    email: props.email,
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${
          process.env.REACT_APP_API_URL +
          APIConstants.getMemberLogs +
          "?email=" +
          memberDetails.email
        }`
      );
      const mapedData = response.data.result.map((item: any, index: any) => ({
        createdAt: formatDates(item.createdAt),
        activityTitle: item.activity,
        createdBy: item.createdBy ? item.createdBy : "-",
      }));
      mapedData.sort(
        (
          a: { createdAt: string | number | Date },
          b: { createdAt: string | number | Date }
        ) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
      setActivityLogData(mapedData);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  activityLogRefresh = fetchData;

  useEffect(() => {
    fetchData();
  }, []);

  const getBackgroundGradient = () => {
    return props.memberTier === "Diamond"
      ? `linear-gradient(to right, ${theme?.color?.diamond}, ${theme?.color?.diamondLight})`
      : props.memberTier === "Gold"
      ? `linear-gradient(to right, ${theme?.color?.gold}, ${theme.color?.goldLight})`
      : `linear-gradient(to right, ${theme?.color?.silver}, ${theme.color?.silverLight})`;
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL + APIConstants.addMember,
        {
          data: emailObj,
        }
      );

      if (response.status === 200) {
        setShowModal(true);
        setUploadError(false);
        setDeleteDialog(false);
        setTimeout(() => {
          setShowModal(false);
          navigate("/members");
        }, 5000);
      } else {
        setShowModal(true);
        setUploadError(true);
        setDeleteDialog(false);
      }
    } catch (error) {
      console.error(error);
      setShowModal(true);
      setUploadError(true);
      setDeleteDialog(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid
      borderRadius={4}
      width={"310px"}
      // width={"20vw"}
      height={"100%"}
      style={{ background: "white" }}
      display={"flex"}
      flexDirection={"column"}
      sx={{ zIndex: 1, p: "5% 2%" }}
    >
      <Drawer
        anchor={"right"}
        open={openActivityLog}
        onClose={() => {
          setActivityLog(false);
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px 0 0 16px",
          },
        }}
      >
        <Grid width={"920px"}>
          <ActivityLogDrawerNew
            memberEmail={memberDetails.email}
            closeDrawer={setActivityLog}
          />
        </Grid>
      </Drawer>
      <Dialog
        open={deleteDialog}
        onClose={() => {
          setDeleteDialog(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent sx={{ pt: 4 }}>
          <DialogContentText
            id="alert-dialog-description"
            sx={{
              fontFamily: theme.font?.fontFamily.primary,
              textAlign: "center",
            }}
          >
            Are you sure you want to <br />
            remove member profile details?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", px: 4, pb: 4 }}>
          {loading ? (
            <Grid display={"flex"} justifyContent={"center"}>
              <Loader size={30} />
            </Grid>
          ) : (
            <>
              <Button
                sx={{ ...buttonStyles.outlinedSecondary }}
                onClick={() => {
                  setDeleteDialog(false);
                }}
              >
                NO
              </Button>
              <Button
                sx={{ ...buttonStyles.containedSecondary }}
                onClick={() => {
                  handleDelete();
                }}
                autoFocus
              >
                Yes
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
      <Grid
        display={"flex"}
        borderBottom={theme.border?.smallGrey}
        p={2}
        height={"15%"}
      >
        <Grid
          width={"35%"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"start"}
          // border={"2px solid red"}
        >
          <Avatar sx={{ width: 72, height: 72, background: "#304C89" }}>
            {start}
            {end}
          </Avatar>
        </Grid>
        <Grid
          width={"60%"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"space-evenly"}
        >
          <Grid display={"flex"} alignItems={"center"} gap={1}>
            <Typography
              fontSize={theme.font?.fontSize.tableBody}
              sx={{
                textAlign: "center",
                color:
                  props.status === filterConstants.Active
                    ? theme?.color?.success
                    : theme?.color?.error,
                backgroundColor:
                  props.status === filterConstants.Active
                    ? theme?.color?.successLight
                    : theme.color?.errorLight,
                borderRadius: "13px",
                fontFamily: theme.font?.fontFamily.primary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              minWidth={"40%"}
              maxWidth={"40%"}
            >
              {props.status}
            </Typography>
            {getDeletePermission("delete") && (
              <Tooltip
                title="Remove Personal Data"
                arrow
                placement="right"
                open={isHovered}
                onClose={() => setIsHovered(false)}
              >
                <IconButton
                  aria-label="delete"
                  sx={{
                    background: theme.color?.error,
                    height: "24px",
                    width: "24px",
                    "&:hover": {
                      background: "#CF0E0E",
                    },
                  }}
                  onClick={() => {
                    setDeleteDialog(true);
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <DeleteOutlineOutlinedIcon
                    sx={{ color: theme.color?.background, height: "16px" }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </Grid>
          <Typography
            sx={{
              fontWeight: 600,
              fontFamily: theme.font?.fontFamily.primary,
              textTransform: "capitalize",
              fontSize: "3vh",
            }}
          >
            {fName}
            {/* {props.memberName} */}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        p={2}
        borderBottom={theme.border?.smallGrey}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-evenly"}
        gap={1}
        height={"25%"}
      >
        <Grid display={"flex"} alignItems={"center"} height={"25%"}>
          <Typography
            width={"60%"}
            sx={{
              color: "#949494",
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: "12px",
            }}
          >
            Loyalty No:
          </Typography>
          <Grid
            display={"flex"}
            alignItems={"center"}
            justifyContent={"end"}
            width={"40%"}
            gap={0.5}
          >
            <Tooltip
              title={isCopied ? "Copied Successfully" : ""}
              placement="right"
            >
              <IconButton
                sx={{ height: "24px", width: "24px" }}
                onClick={handleCopyClick}
              >
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
            <Typography
              sx={{
                color: "#797B83",
                fontWeight: 700,
                fontFamily: theme.font?.fontFamily.primary,
                fontSize: "12px",
              }}
              textAlign={"end"}
            >
              {props.loyaltyNo}
            </Typography>
          </Grid>
        </Grid>

        {props?.show_yuu && props?.yuu_status === "LINKED" ? (
          <>
            <Grid display={"flex"} alignItems={"center"} height={"25%"}>
              <Typography
                width={"60%"}
                sx={{
                  color: "#949494",
                  fontFamily: theme.font?.fontFamily.primary,
                  fontSize: "12px",
                }}
              >
                yuu ID
              </Typography>
              <Grid
                display={"flex"}
                alignItems={"center"}
                justifyContent={"end"}
                width={"40%"}
                gap={0.5}
              >
                <Typography
                  sx={{
                    color: "#797B83",
                    fontWeight: 700,
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: "12px",
                  }}
                  textAlign={"end"}
                >
                  {props.yuuId}
                </Typography>
              </Grid>
            </Grid>
          </>
        ) : null}

        <Grid display={"flex"} alignItems={"center"} height={"25%"}>
          <Typography
            width={"60%"}
            sx={{
              color: "#949494",
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: "12px",
            }}
          >
            Points Validity:
          </Typography>
          <Grid
            width={"40%"}
            display={"flex"}
            justifyContent={"end"}
            alignItems={"center"}
          >
            <IconButton onClick={handleClick}>
              <InfoOutlinedIcon
                sx={{
                  height: "16px",
                  width: "16px",
                  color: theme.color?.secondary,
                }}
              />
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <Grid width={"282px"} overflow={"auto"} pr={1}>
                <ul style={{ listStyleType: "disc" }}>
                  {props.pointsValidityData?.map((points: any) => (
                    <li
                      style={{
                        fontFamily: theme.font?.fontFamily.primary,
                        fontSize: "12px",
                        color: theme.color?.newFilterGrey,
                      }}
                    >
                      <span style={{ color: theme.color?.secondary }}>
                        {Math.round(points.points)}
                      </span>
                      &nbsp; Points expiring on{" "}
                      {getFormattedDate(
                        points.expiryDate,
                        dateFormat.DOMMMMYYYY
                      )}
                    </li>
                  ))}
                </ul>
              </Grid>
            </Menu>
            <Typography
              textAlign={"end"}
              sx={{
                color: "#797B83",
                fontWeight: 700,
                fontFamily: theme.font?.fontFamily.primary,
                fontSize: "12px",
              }}
            >
              {Math.round(+props.loyaltyPoints)}
            </Typography>
          </Grid>
        </Grid>
        <Grid display={"flex"} height={"25%"} alignItems={"center"}>
          <Typography
            width={"60%"}
            sx={{
              color: "#949494",
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: "12px",
            }}
          >
            Car Park Balance:
          </Typography>
          <Typography
            width={"40%"}
            textAlign={"end"}
            sx={{
              color: "#797B83",
              fontWeight: 700,
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: "12px",
            }}
          >
            ${props.carpark}
          </Typography>
        </Grid>
        <Grid display={"flex"} height={"25%"} alignItems={"center"}>
          <Typography
            width={"60%"}
            sx={{
              color: "#949494",
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: "12px",
            }}
          >
            Member Since:
          </Typography>
          <Typography
            width={"40%"}
            sx={{
              color: "#797B83",
              fontWeight: 700,
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: "12px",
            }}
            textAlign={"end"}
          >
            {getFormattedDate(props.memberSince, dateFormat.DDMMMYYYY)}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        p={2}
        gap={1}
        borderBottom={theme.border?.smallGrey}
        height={"20%"}
      >
        <Typography
          sx={{
            color: "#252836",
            fontWeight: 700,
            fontFamily: theme.font?.fontFamily.primary,
          }}
        >
          Tier
        </Typography>
        <Typography
          alignItems={"center"}
          height={"30%"}
          justifyContent={"center"}
          display={"flex"}
          px={1}
          py={0.2}
          sx={{
            color: theme.color?.background,
            backgroundImage: getBackgroundGradient(),
            borderRadius: "32px",
            fontFamily: theme?.font?.fontFamily.primary,
            fontSize: "16px",
          }}
        >
          {props.memberTier}
        </Typography>
        <Grid display={"flex"} justifyContent={"center"}>
          {props.nextSlab === "" ? (
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                color: "#595959",
                fontWeight: 400,
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              
              {props?.currentSlab === "Diamond" && +props?.gap_to_renew === 0 ? (
                <>
                  <span>
                    Enjoy your Diamond membership till{" "}
                    {getFormattedDate(props.renew_by, dateFormat.DOMMMMYYYY)}
                  </span>
                </>
              ) : props.currentSlab === "Diamond" ? (
                <>
                  Spend S${Math.round(+props?.gap_to_renew)} more to retain{" "}
                  {props.currentSlab} tier <br></br>
                  <span style={{ color: "black", fontWeight: 700 }}>
                    by {getFormattedDate(props.renew_by, dateFormat.DOMMMMYYYY)}{" "}
                  </span>
                </>
              ) : (
                <>
                  Spend S${Math.round(+props.gap_to_renew)} more to stay in{" "}
                  {props.currentSlab} <br></br>
                  <span style={{ color: "black", fontWeight: 700 }}>
                    by {getFormattedDate(props.renew_by, dateFormat.DOMMMMYYYY)}{" "}
                  </span>
                </>
              )}
            </Typography>
          ) : (
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                color: "#595959",
                fontWeight: 400,
                fontSize: "12px",
                textAlign: "center",
              }}
            >
              Spend S${Math.round(+props.gap_to_upgrade)} more to reach{" "}
              {props.nextSlab} <br></br>
              <span style={{ color: "black", fontWeight: 700 }}>
                by {getFormattedDate(props.upgrade_by, dateFormat.DOMMMMYYYY)}
              </span>
            </Typography>
          )}
        </Grid>
      </Grid>
      <Grid
        textAlign={"center"}
        display={"flex"}
        flexDirection={"column"}
        sx={{ padding: "16px 8px" }}
        height={"40%"}
      >
        <Grid display={"flex"} mb={1}>
          <Grid width={"70%"} display={"flex"} alignItems={"center"}>
            <Typography
              textAlign={"left"}
              sx={{
                paddingLeft: 1,
                fontSize: "14px",
                fontWeight: 600,
                color: "#252836",
                fontFamily: theme.font?.fontFamily.primary,
              }}
            >
              Activity Log
            </Typography>
          </Grid>
          <Grid
            width={"30%"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            {(constant.domain === process.env.REACT_APP_ADMIN_DOMAIN ||
              constant.domain === process.env.REACT_APP_CSA_DOMAIN) && (
              <Button
                sx={{
                  ...buttonStyles.buttonText,
                  color: theme.color?.secondary,
                  textTransform: "capitalize",
                }}
                onClick={() => {
                  setActivityLog(true);
                }}
                disabled={!activityLogData.length}
              >
                View All
              </Button>
            )}
          </Grid>
        </Grid>
        <Grid
          sx={{ overflowY: "auto", height: "220px", ...tableStyle.scrollbar }}
        >
          {loading ? (
            <Grid
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              height={"100%"}
            >
              <Loader />
            </Grid>
          ) : (
            <Grid>
              {activityLogData.length ? (
                activityLogData.slice(0, 5).map((singleLog: any) => {
                  return (
                    <ActivityLogNew
                      title={singleLog.activityTitle}
                      createdAt={singleLog.createdAt}
                      createdBy={singleLog.createdBy}
                    />
                  );
                })
              ) : (
                <Grid
                  height={"100%"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <img src={NoActivity} />
                </Grid>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
      {showModal &&
        (uploadError ? (
          <BasicModal
            title={"Member already Deleted. Delete request pending"}
            success={false}
            setState={setShowModal}
          />
        ) : (
          <BasicModal
            title={
              "Delete member request is raised. It will take 24 hours to reflect in the system"
            }
            success={true}
            setState={setShowModal}
          />
        ))}
    </Grid>
  );
};

export default MemberDetailsHeaderNew;
